module.exports = __webpack_public_path__ + "img/following-up-en.5b1b1152.png";